import { getStore } from '../store/store';
import { TasksLoadState } from '../store/schema/TasksLoadState';

export function getLoadState(id: string): TasksLoadState {
    const loadState = getStore().loadState.get(id);
    return loadState ? loadState : 'None';
}
